/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N0, N200, N30, N60A } from '@atlaskit/theme/colors';
import { dialogWidth, grid } from '@atlassian/search-dialog';

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerDefaultLoadingWrapper = styled.div(function (_ref) {
  var isReadingAids = _ref.isReadingAids;
  return isReadingAids ? "\n        width: 100%;\n\t\t\t\theight: 92px;\n        padding: ".concat("var(--ds-space-300, 24px)", ";\n        box-sizing: border-box;\n      ") : "\n\t\t".concat("\n        width: ", dialogWidth, ";\n\t\t", "\n        margin-top: ").concat(grid.px, ";\n        ");
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerSearchLoadingBorder = styled.div(function (_ref2) {
  var isStreaming = _ref2.isStreaming;
  return {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    borderRadius: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: isStreaming ? "var(--ds-space-100, 8px)".concat(" 0 ", "var(--ds-space-100, 8px)", " 0") : '0px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    zIndex: 3,
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 ".concat("var(--ds-space-050, 4px)", " ", "var(--ds-space-100, 8px)", " ", "var(--ds-space-negative-025, -2px)", " ", N60A, ", 0 0 1px ").concat(N60A), ")"),
    '&::before': {
      content: "''",
      width: '1000vw',
      height: '1000vh',
      // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
      left: 'calc(-500vw + 50%)',
      // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
      top: 'calc(-500vh + 50%)',
      position: 'absolute',
      zIndex: -2,
      borderRadius: "var(--ds-space-050, 4px)",
      background: 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)',
      animation: 'rotate 2s infinite linear',
      filter: 'blur(25px)'
    },
    '&::after': {
      content: "''",
      width: "100% - ".concat("var(--ds-space-050, 4px)"),
      height: "100% - ".concat("var(--ds-space-050, 4px)"),
      inset: '1px',
      position: 'absolute',
      zIndex: -1,
      borderRadius: "var(--ds-space-050, 4px)",
      backgroundColor: "var(--ds-surface-overlay, ".concat(N0, ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes rotate': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      from: {
        transform: 'rotate(0deg)'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      to: {
        transform: 'rotate(360deg)'
      }
    }
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerLoadingTitleSection = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  height: '24px',
  gap: "var(--ds-space-025, 2px)",
  color: "var(--ds-text-subtlest, ".concat(N200, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerLoadingSkeletonWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: "var(--ds-space-200, 16px)",
  gap: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerLoadingPill = styled.div({
  display: 'flex',
  width: '100%',
  height: '16px',
  borderRadius: '8px',
  background: "var(--ds-skeleton, ".concat(N30, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsLoadingPill = styled.div(function (_ref3) {
  var width = _ref3.width,
    height = _ref3.height;
  return {
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: width ? width : '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: height ? height : '16px',
    borderRadius: '8px',
    background: "linear-gradient(to right, ".concat("var(--ds-background-neutral, rgba(240, 241, 244, 1))", ", ", "var(--ds-background-input-pressed, rgba(252, 252, 252, 1))", ")"),
    animation: 'shimmer 1.5s linear infinite alternate',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes shimmer': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      from: {
        background: "linear-gradient(to right, ".concat("var(--ds-background-neutral, rgba(240, 241, 244, 1))", ", ", "var(--ds-background-input-pressed, rgba(252, 252, 252, 1))", ")")
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      to: {
        background: "linear-gradient(to right, ".concat("var(--ds-background-neutral, rgba(240, 241, 244, 1))", ", ", "var(--ds-background-input-pressed, rgba(252, 252, 252, 1))", ")")
      }
    }
  };
});

// Streaming Markdown Container
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerLoadingStreamMarkdownContainer = styled.div({
  maxHeight: '160px',
  overflowY: 'auto',
  padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-300, 24px)", " ", "var(--ds-space-0, 0px)", " ", "var(--ds-space-300, 24px)")
});

// copied from /platform/packages/search/search-ai/src/ai-answer-dialog/ai-answer-body/ai-answer-result/styled.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerResultBlurSection = styled.div({
  background: "linear-gradient( 180deg, ".concat("var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0))", " 0%, ", "var(--ds-surface-overlay, ".concat(N0, ")"), " 100% )"),
  height: "var(--ds-space-500, 40px)",
  width: '100%',
  position: 'relative',
  display: 'block',
  margin: "calc(".concat("var(--ds-space-500, 40px)", " * -1) 1px 0 1px")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var GeneratingContainer = styled.div({
  display: 'flex',
  height: '92px',
  boxSizing: 'border-box',
  padding: "var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-300, 24px)", " 0px ", "var(--ds-space-300, 24px)")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var GeneratingText = styled.div({
  marginLeft: "var(--ds-space-025, 2px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});